import script from "./ContactProviderSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactProviderSelector.vue?vue&type=script&lang=ts&setup=true"

import "./ContactProviderSelector.vue?vue&type=style&index=0&id=581c0dbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581c0dbe"]])

export default __exports__